import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.css';
import App from './screen/App';
import reportWebVitals from './reportWebVitals';
import { ContextWrapper } from './context/contextWrapper';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ContextWrapper>
      <App />
    </ContextWrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
